import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'get-reset-link.page',
  templateUrl: './get-reset-link.html',
})
export class GetResetLinkPage implements OnInit {
  constructor(private route: ActivatedRoute) {}

  _emailAddress: string;

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this._emailAddress = params['emailAddress'] || null;
    });
  }
}
